import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    no: "Nº 01",
    title: "The sealed box arrives",
    copy: "A parcel with no return address lands on your doormat. Inside: letters, artifacts, a candle, and one instruction — do not open until dusk.",
    img: "https://images.unsplash.com/photo-1631867519984-2eb223627ddb?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "Wax sealed letter and box",
    arch: true,
  },
  {
    no: "Nº 02",
    title: "Gather your inner circle",
    copy: "Two to six players. Phones inside the box. Lights low, curtains drawn. The room becomes the theatre and you become the cast.",
    img: "https://images.unsplash.com/photo-1524694344997-f872df30b642?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "A dimly lit room awaiting the ritual",
    arch: false,
  },
  {
    no: "Nº 03",
    title: "Break the wax and begin",
    copy: "The audio companion speaks first. For ninety minutes it guides your hands through letters, keys and choices the house will remember.",
    img: "https://images.unsplash.com/photo-1572306851373-fbc859394345?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    alt: "A single votive candle burning",
    arch: true,
  },
];

export const HowItWorks = () => (
  <section
    id="experience"
    data-testid="experience-section"
    className="mx-auto max-w-7xl px-6 py-24 sm:px-12 sm:py-36"
  >
    <Reveal>
      <p className="font-cinzel text-[11px] tracking-[0.45em] text-gold/80">
        THE EXPERIENCE
      </p>
      <h2 className="mt-6 max-w-2xl font-serif text-3xl font-light leading-tight text-cream sm:text-5xl">
        Every episode begins <em className="italic text-gold">with a knock from the postman.</em>
      </h2>
    </Reveal>
    <div className="mt-20 grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8 lg:gap-12">
      {STEPS.map((step, i) => (
        <Reveal key={step.no} delay={i * 0.12}>
          <div data-testid={`experience-step-${i + 1}`} className="group">
            <div
              className={`overflow-hidden border border-gold/15 ${
                step.arch ? "rounded-t-[10rem]" : ""
              } ${i === 1 ? "md:mt-14" : ""}`}
            >
              <img
                src={step.img}
                alt={step.alt}
                loading="lazy"
                className="aspect-[4/5] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
              />
            </div>
            <p className="mt-8 font-cinzel text-[11px] tracking-[0.35em] text-gold">
              {step.no}
            </p>
            <h3 className="mt-3 font-serif text-2xl text-cream">{step.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-sand">{step.copy}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
